import classes from './Home.module.css';
import MultiCarousel from "react-multi-carousel";
import {useState, useEffect} from 'react';
import Carousel from 'react-bootstrap/Carousel';
import "react-multi-carousel/lib/styles.css";
import image from '../../Designs/1.jpg';
import delivery from '../../Designs/delivery-icon.png';
import {Link} from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {MOSTSOLD} from '../../URLS';
import PAGES from '../../URLS';

const Home = ({products}) => {
    const carouselMediaQueries = {
        large: {
            breakpoint: {
                max:2000,
                min:1000,
            },
            items: 4
        },
        desktop: {
            breakpoint: {
                max:1000,
                min:500
            },
            items: 3
        },
        mobile: {
            breakpoint: {
                max:1000,
                min:500
            },
            items: 2
        }
    }
    const testimonies = [
        [
            "De todo el mundo, soy el que mas ama Valentina",
            "Isaiah Cedano"
        ],
        [
            "Una delicia!",
            "Roselide Olivo"
        ]
    ]
    return (
        <>
            <div className={"outer"}>
                <div className={classes.specializedContainer}>
                    <div>
                        <h3>Especializado</h3>
                        <div className={classes.specializedSections}>
                            <h6>Todos</h6>
                            <h6>Dulces y Postres</h6>
                            <h6>Salados</h6>
                            <h6>Panes y Envasados</h6>
                            <h6>Bocaditos</h6>
                        </div>
                    </div>
                    <MultiCarousel
                        draggable={false}
                        autoPlay={true}
                        infinite={true}
                        showDots={true}
                        arrows={false}
                        transitionDuration={800}
                        customTransition={
                            "transform 800ms ease-out"
                        }
                        autoPlaySpeed={5000}
                        renderDotsOutside={true}
                        containerClass={`react-multi-carousel-list ${classes.carousel}`}
                        dotListClass={`react-multi-carousel-dot-list ${classes.carouselDotList}`}
                        responsive={carouselMediaQueries}>
                        {
                            Object.entries(MOSTSOLD).map(([text, link], index) => {
                                const productInfo = products.filter(({title}) => text===title)[0];

                                return <div className={classes.carouselItem} key={index}>
                                    <img src={image}/>
                                    <Link to={link}>{text}</Link>
                                    <h6>{`Desde S/${
                                      typeof(productInfo)==='undefined' ?
                                      '0' : productInfo.price
                                    }`}</h6>
                                </div>
                            })
                        }
                    </MultiCarousel>
                </div>
                <div className={classes.deliverySection}>
                    <img src={image}/>
                    <div>
                        <span>
                            <img src={delivery}/>
                        </span>
                        <div>
                            <h4>Delivery</h4>
                            <h5>Lorem Ipsum</h5>
                        </div>
                    </div>
                </div>
                <div className={classes.testimonialSection}>
                    <h4 className={`${classes.testimony} ${classes.testimonial}`}>Amor Para Valentina</h4>
                    <Carousel className={`${classes.carouselTestimonial} ${classes.testimonial}`}
                    pause={false} interval={6000} variant={"dark"}>
                        {
                            testimonies.map(([review, author], index) => {
                                return <Carousel.Item key={index} className={classes.testimonyContainer}>
                                        <h6 className={classes.testimony}>{review}</h6>
                                        <p className={classes.testimony}>{author}</p>
                                    </Carousel.Item>
                            })
                        }
                    </Carousel>
                </div>
                <div className={classes.footer}>
                  <div className={classes.footerLogoContainer}>
                    <span/>
                    <img src={delivery}/>
                  </div>
                  <div className={classes.footerExternalData}>
                    <div>
                      <h4>Preguntas Frequentes</h4>
                      <ul className={classes.questions}>
                        <li>Cuanto es el tiempo de entrega?</li>
                        <li>Donde queda su tienda?</li>
                      </ul>
                    </div>
                    <div>
                      <h4>Links de Interes</h4>
                      <ul className={classes.externalLinks}>
                        <li>
                          <Link to={PAGES.PERSONALIZED}>
                            Pedidos Personalizados
                          </Link>
                        </li>
                        <li>
                          <Link to={PAGES.TERMSCONDITIONS}>
                            Terminos y Condiciones
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.footerRegisterForm}>
                    <h4>Registrate Para Nuestras Promociones!</h4>
                    <p>Obten las promociones mas actualizadas</p>
                    <div>
                      <label>Nombre</label>
                      <input/>
                      <label>Correo Electronico</label>
                      <input/>
                    </div>
                  </div>
                  <div className={classes.footerPaymentMethods}>

                  </div>
                  <div className={classes.footerLicenseSocial}>
                    <h5>License</h5>
                    <div>
                      <FacebookIcon/>
                      <WhatsAppIcon/>
                      <InstagramIcon/>
                    </div>
                  </div>
                </div>
            </div>
        </>
    );
};

export default Home;
